import React from 'react';
import { motion } from 'framer-motion';

const ProgressBar = ({ 
  progress, 
  message, 
  showPercentage = true,
  remainingTime = null,
  processingSpeed = null,
  showStats = false
}) => {
  return (
    <div className="w-full bg-gray-100 rounded-lg overflow-hidden">
      <motion.div
        className="h-2 bg-gradient-to-r from-purple-500 to-blue-500"
        initial={{ width: 0 }}
        animate={{ width: `${progress}%` }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
      />
      
      {(message || showPercentage || remainingTime || processingSpeed) && (
        <div className="px-3 py-2">
          {/* 主要信息行 */}
          <div className="flex justify-between items-center">
            {message && (
              <span className="text-sm text-gray-600">{message}</span>
            )}
            {showPercentage && (
              <span className="text-sm font-medium text-purple-600">
                {Math.round(progress)}%
              </span>
            )}
          </div>

          {/* 🆕 統計信息行 */}
          {showStats && (remainingTime || processingSpeed) && (
            <div className="flex justify-between items-center mt-2 text-xs text-gray-500">
              {remainingTime && (
                <span className="flex items-center gap-1">
                  <span className="inline-block w-1.5 h-1.5 bg-blue-500 rounded-full animate-pulse"></span>
                  剩餘時間: {remainingTime}
                </span>
              )}
              {processingSpeed && (
                <span className="flex items-center gap-1">
                  <span className="inline-block w-1.5 h-1.5 bg-green-500 rounded-full"></span>
                  速度: {processingSpeed}
                </span>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProgressBar;